import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Industries } from "@/components/Industries";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { WhyNorex } from "@/components/WhyNorex";
import { Testimonials } from "@/components/Testimonials";
import { BuyerSupplier } from "@/components/BuyerSupplier";
import { RFQSection } from "@/components/RFQSection";
import { SupplierSection } from "@/components/SupplierSection";
import { GlobalReach } from "@/components/GlobalReach";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { SiteImagesProvider } from "@/lib/siteImages";

export default function HomePage() {
  return (
    <SiteImagesProvider>
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <About />
      <Industries />
      <Services />
      <Process />
      <WhyNorex />
      <Testimonials />
      <BuyerSupplier />
      <RFQSection />
      <SupplierSection />
      <GlobalReach />
      <Contact />
      <Footer />
    </main>
    </SiteImagesProvider>
  );
}
